import { createI18n as externalCreate } from '@wix/cli-i18n';
import messages from './messages.json' with { type: 'json' };

export function createI18nT() {
  const i18n = externalCreate(messages);
  return i18n.t.bind(i18n);
}
